import styled from 'styled-components';
import { Select, Typography } from 'antd';

export const AccountDropdownMenuWrapper = styled.div`
  & .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    font-weight: 600;
    background: ${({ theme }) => theme.colorPrimary};
    color: ${({ theme }) => theme.colorWhite};
  }

  & .ant-select-item-option-active:not(.ant-select-item-option-disabled, .ant-select-item-option-selected) {
    opacity: 0.7;
    font-weight: 600;
    background: ${({ theme }) => theme.colorPrimary};
    color: ${({ theme }) => theme.colorWhite};
  }
`;

export const AccountDropdownTitle = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 22px;
  min-width: 120px;
  color: ${({ theme }) => theme.colorTextDescription};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colorPrimary};
  }
`;

export const AccountDropdownSelectedText = styled(Typography.Text)`
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AccountSelectWrapper = styled(Select)`
  max-width: 170px;
  display: flex;
  align-items: center;

  &:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0;
    height: 22px;
    border: 0;
  }

  & .ant-select-selector .ant-select-selection-search {
    inset-inline-start: 0;
    inset-inline-end: 0;
  }

  &:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
    height: 22px;
    max-width: 135px;
    padding-right: 15px;
  }

  & .ant-select-arrow {
    display: block;
  }
`;
